import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18;

import styled, { css } from 'styled-components';
import { BORDER_POSITIONS, INPUT_SIZES } from "../constants";
import { inputStateOutlineStyles } from "../inputStateOutlineStyles";
import { getHexToRgb, getLineHeight, getRem, msInputStyles, transitionAnimation, typographyBody1 } from "./../../core";
import { InputSuffixElement } from "./InputSuffixElement";
var focusStyles = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", ";\n\n  & ~ ", " {\n    /* No other way to apply styling */\n    svg {\n      fill: ", ";\n    }\n  }\n"])), inputStateOutlineStyles.focus, InputSuffixElement, function (_ref) {
  var theme = _ref.theme;
  return theme.color.primary['500'].value;
});
var isRequiredStyles = css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  &::after {\n    color: ", ";\n    content: '*';\n    font-size: ", ";\n    line-height: 0;\n    margin-left: ", ";\n    position: absolute;\n    right: ", ";\n    top: ", ";\n    ", "\n\n    ", "\n        ", "\n  }\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return theme.color.text.light.secondary.value;
}, getRem('17px'), getRem('2px'), function (_ref3) {
  var theme = _ref3.theme;
  return theme.size.spacing.small.value;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.size.spacing.medium.value;
}, function (_ref5) {
  var hasError = _ref5.hasError,
      isRequired = _ref5.isRequired,
      theme = _ref5.theme;
  return isRequired && hasError && css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n        color: ", ";\n      "])), theme.color.system.negative[500].value);
}, function (_ref6) {
  var hasError = _ref6.hasError,
      isFocused = _ref6.isFocused,
      isReadOnly = _ref6.isReadOnly,
      isRequired = _ref6.isRequired,
      theme = _ref6.theme;
  return !hasError && !isReadOnly && isFocused && isRequired && css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n        color: ", ";\n      "])), theme.color.primary['500'].value);
}, function (_ref7) {
  var isDisabled = _ref7.isDisabled,
      isRequired = _ref7.isRequired,
      theme = _ref7.theme;
  return isRequired && isDisabled && css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n        color: ", ";\n      "])), theme.color.text.light.disabled.value);
});
var hideBorderColorStyles = css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  border-left-color: ", ";\n  border-right-color: ", ";\n"])), function (_ref8) {
  var hideBorder = _ref8.hideBorder;
  return hideBorder === BORDER_POSITIONS.LEFT && 'transparent';
}, function (_ref9) {
  var hideBorder = _ref9.hideBorder;
  return hideBorder === BORDER_POSITIONS.RIGHT && 'transparent';
});
var hideBorderStyles = css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n"])), function (_ref10) {
  var hideBorder = _ref10.hideBorder,
      theme = _ref10.theme;
  return hideBorder === BORDER_POSITIONS.LEFT && css(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n      border-left: 1px solid transparent;\n      border-radius: 0 ", " ", " 0;\n    "])), theme.size.borderRadius.large.value, theme.size.borderRadius.large.value);
}, function (_ref11) {
  var hideBorder = _ref11.hideBorder,
      theme = _ref11.theme;
  return hideBorder === BORDER_POSITIONS.RIGHT && css(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n      border-radius: ", " 0 0 ", ";\n      border-right: none;\n    "])), theme.size.borderRadius.large.value, theme.size.borderRadius.large.value);
});
var inputDividerStyles = css(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref12) {
  var hasError = _ref12.hasError,
      inputDivider = _ref12.inputDivider,
      theme = _ref12.theme;
  return css(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n    border-left: ", ";\n    border-left-color: ", ";\n    border-right: ", ";\n    border-right-color: ", ";\n  "])), inputDivider === BORDER_POSITIONS.LEFT && "1px solid rgba(".concat(getHexToRgb(theme.color.additional.dark.value), ", 0.3)"), hasError && inputDivider === BORDER_POSITIONS.LEFT && theme.color.system.negative[500].value, inputDivider === BORDER_POSITIONS.RIGHT && "1px solid rgba(".concat(getHexToRgb(theme.color.additional.dark.value), ", 0.3)"), hasError && inputDivider === BORDER_POSITIONS.RIGHT && theme.color.system.negative[500].value);
});
var sizeStyles = css(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  height: ", ";\n  ", "\n  ", "\n"])), getRem(36), function (_ref13) {
  var size = _ref13.size,
      theme = _ref13.theme;
  return size === INPUT_SIZES.LARGE && css(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n      font-size: ", ";\n      height: ", ";\n      line-height: ", ";\n      &::-webkit-input-placeholder {\n        line-height: normal;\n      }\n    "])), theme.font.size["default"].value, getRem(40), getLineHeight('16px', '24px'));
}, function (_ref14) {
  var size = _ref14.size;
  return size === INPUT_SIZES.SMALL && css(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n      height: ", ";\n      line-height: normal;\n    "])), getRem(32));
}); // Note: BaseInput is a label since it wraps input component together with the actual label

var BaseInput = styled.label(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n  align-items: center;\n  box-shadow: none;\n  box-sizing: border-box;\n  display: flex;\n  flex: 1 1 100%;\n  flex-direction: column;\n  outline: none;\n  padding-left: ", ";\n  padding-right: ", ";\n  position: relative;\n  width: 100%;\n  ", "\n  ", "\n    ", "\n    ", ";\n  ", "\n\n  &::placeholder {\n    color: ", ";\n  }\n\n  &::-ms-clear,\n  &::-ms-reveal {\n    display: none;\n  }\n\n  ", "\n  ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n", "\n"])), getRem(12), function (_ref15) {
  var theme = _ref15.theme;
  return theme.size.spacing.medium.value;
}, msInputStyles, transitionAnimation('border, box-shadow'), function (_ref16) {
  var theme = _ref16.theme;
  return typographyBody1(theme);
}, inputStateOutlineStyles["default"], function (_ref17) {
  var isRequired = _ref17.isRequired;
  return isRequired && isRequiredStyles;
}, function (_ref18) {
  var theme = _ref18.theme;
  return "rgba(".concat(getHexToRgb(theme.color.additional.dark.value), ", 0.4)");
}, function (_ref19) {
  var hasError = _ref19.hasError,
      isDisabled = _ref19.isDisabled,
      isFocused = _ref19.isFocused,
      isReadOnly = _ref19.isReadOnly;
  return !isFocused && !hasError && !isDisabled && !isReadOnly && css(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n      &:hover {\n        ", ";\n      }\n    "])), inputStateOutlineStyles.hover);
}, function (_ref20) {
  var hasError = _ref20.hasError;
  return hasError && inputStateOutlineStyles.error;
}, function (_ref21) {
  var hasError = _ref21.hasError,
      isFocused = _ref21.isFocused;
  return hasError && isFocused && inputStateOutlineStyles.errorAndFocus;
}, function (_ref22) {
  var hasError = _ref22.hasError,
      isDisabled = _ref22.isDisabled,
      isReadOnly = _ref22.isReadOnly;
  return !hasError && !isDisabled && !isReadOnly && hideBorderColorStyles;
}, hideBorderStyles, inputDividerStyles, function (_ref23) {
  var isReadOnly = _ref23.isReadOnly,
      theme = _ref23.theme;
  return isReadOnly && css(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n      background-color: ", ";\n      border-color: transparent;\n      box-shadow: none;\n    "])), theme.color.state["default"].disabled.value);
}, function (_ref24) {
  var isDisabled = _ref24.isDisabled,
      theme = _ref24.theme;
  return isDisabled && css(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["\n      background-color: ", ";\n      border-color: transparent;\n      cursor: not-allowed;\n    "])), theme.color.state["default"].disabled.value);
}, sizeStyles, function (_ref25) {
  var hasError = _ref25.hasError,
      isDisabled = _ref25.isDisabled,
      isFocused = _ref25.isFocused,
      isReadOnly = _ref25.isReadOnly;
  return !hasError && !isDisabled && !isReadOnly && isFocused && focusStyles;
}, function (_ref26) {
  var hasError = _ref26.hasError,
      isDisabled = _ref26.isDisabled,
      isFocused = _ref26.isFocused,
      isReadOnly = _ref26.isReadOnly;
  return !hasError && !isDisabled && !isReadOnly && isFocused && focusStyles;
});
export { BaseInput };